module.exports = __webpack_public_path__ + "9297120e40658e83b23c9d73f0d71f4a.jpg";